/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRatewareTariffCode.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/rateware-tariff-code";

export class AutogenModelRatewareTariffCode<RowType extends ModelRow> extends Endpoint<RowType, RowRatewareTariffCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRatewareTariffCode extends ModelRow<RowRatewareTariffCodeFields> {
	constructor(values?: Partial<RowRatewareTariffCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRatewareTariffCodeFields {
	add_timestamp: Date;
	add_userid: string;
	company_id: string;
	mod_timestamp: Date;
	mod_userid: string;
	rateware_product_info: string;
	rateware_tariff_date: string;
	rateware_tariff_name: string;
	rtc_uid: number;
}

